import CommonAppbar from '../components/common/CommonAppbar';
import * as React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import {useNavigate} from 'react-router-dom';

export default function EditProfile() {
  const navigate = useNavigate();

  return <>
    <CommonAppbar isMainPage={false} pageHeader={'Edit profile'}/>
    <Stack spacing={2} sx={{m: 1}}>
      <TextField
        label="UserName"
        id="outlined-start-adornment"
        sx={{m: 1, width: '25ch'}}
        defaultValue={'userABC'}
        InputProps={{
          startAdornment: <InputAdornment position="start">@</InputAdornment>,
        }}
      />
      <FormGroup>
        <FormControlLabel control={<Checkbox/>} label="Hide my name"/>
        <FormControlLabel control={<Checkbox/>} label="Hide my profile pic"/>
      </FormGroup>

      <Button variant="contained" size="large" startIcon={<SaveIcon/>} onClick={() => navigate(-1)}>
        Save
      </Button>
    </Stack>

  </>
}
